/** Roadmap header controls including navigation, zoom level, and other options */
export const ROADMAP_CONTROLS_Z_INDEX = 4

export const ROADMAP_HEADER_Z_INDEX = 3

export const ROADMAP_MARKER_NUB_Z_INDEX = 2

export const ROADMAP_CELL_Z_INDEX = 2

/** We had to do this to make sure that the assignee tooltip would not get clipped by the row beneath it */
export const ROADMAP_ROW_HOVER_Z_INDEX = 1

/** Needs to be higher than cell index to display blue outline overtop borders */
export const ROADMAP_HIGHLIGHT_ROW_Z_INDEX = 3

export const ROADMAP_NAVIGATION_ARROW_Z_INDEX = 1

export const ROADMAP_PILL_Z_INDEX = 0

export const ROADMAP_PILL_DRAG_HANDLE_Z_INDEX = 1

export const ROADMAP_PILL_ASSIGNEE_TOOLTIP_INDEX = 1
